/**
 * Centralises pathname parsing for ViewPAF so route behaviour is easy to find
 * and test without scattering `window.location` across the component.
 */

/**
 * @param {string} pathname - typically `window.location.pathname`
 */
export function getViewPafRouteContext(pathname) {
  const segments = pathname.split("/").filter(Boolean);
  const thirdSegment = segments[2];

  return {
    /** Same index as legacy `pathname.split("/")[3]` (patient / product type segment). */
    pathSegment3: thirdSegment,
    isRenewal: pathname.includes("renew"),
    /** Normalised product/patient type segment used on renew flows. */
    typeOfForRenew:
      thirdSegment === "womanOfCPRenew2" ? "womanOfCP" : thirdSegment,
    isPatientInitiationOrRenew:
      pathname.includes("patient-initiation") || pathname.includes("renew"),
  };
}
